import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import "./index.css";
import { applyFontSize, readStoredFontSize } from "./hooks/useFontSize";
import { initSentry } from "./lib/sentry";

// Initialise Sentry as early as possible, before the app renders.
initSentry();

applyFontSize(readStoredFontSize());

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div className="p-8">
          <h1 className="text-2xl font-bold">Something went wrong</h1>
          <pre className="my-4 text-red-500">
            {error instanceof Error ? error.message : String(error)}
          </pre>
          <button
            onClick={resetError}
            className="rounded bg-blue-600 px-4 py-2 text-white"
          >
            Try Again
          </button>
        </div>
      )}
    >
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>
);
